"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.summarizeString = exports.formatString = void 0;
/**
 * Summary:
 *     Replaces the format item in a specified string with the string representation
 *     of a corresponding string in a specified array.
 * @param  {string} text A composite format string.
 * @param  {string[]} args An string array that contains zero or more strings to format.
 * @return {string} A copy of format in which the format items have been replaced by the string representation of the corresponding strings in args.
 * {0} day left
 *
 * StringHelper.format('{0} day left', 'One')
 */
var formatString = function (text) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return text.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] !== "undefined" ? args[number] : match;
    });
};
exports.formatString = formatString;
var summarizeString = function (text, length) {
    return text.length > length ? text.substr(0, length).concat("...") : text;
};
exports.summarizeString = summarizeString;
//# sourceMappingURL=string-helper.js.map